import React from 'react';

import styled, { css } from 'styled-components';

const ButtonEditor = styled.button`

    /*Estilos base do botão*/
    border-radius:3px;
    border:none;
    padding:.5rem 1rem;
    transition: all .5s;
    font-weight: bold;
    ${props => props.color === "primary" && css`
        background: #ecf0f1;
        color: #666;
        &:hover{
            background: #bdc3c7;
            color: #fff;
        }
        &:active{
            background: #95a5a6;
            color: #fff;
        }
    `}
    ${props => props.color === "secondary" && css`
        background: #34495e;
        color: white;
    `}
    ${props => props.color === "success" && css`
        background: #2ecc71;
        color: white;
        
        &:hover{
            background: #27ae60;
        }
        &:active{
            background: #20914f;
        }
    `}
    ${props => props.color === "danger" && css`
        background: #c0392b;
        color: white;
    `}
    ${props => props.color === "warning" && css`
        background: #f39c12;
        color: white;
    `}
`

export default ButtonEditor;